import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { SowChangeBlockedProjectRequestSchema } from "@remi/types/sow-change/blocked-project";

// Optional so attempts recorded before the review chose holds still parse.
export const ReviewChangeOrderRequestTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REVIEW_CHANGE_ORDER_REQUEST),
  blockedProjects: z.array(SowChangeBlockedProjectRequestSchema).min(1).optional(),
});
